<!-- 数据展示 -->
<template>
    <div class="resource-display">
        <div class="resource-display-value">
            <span> <count-up :id-name="'code_' + '建设总量'" :end-val="rescourcecount" countSize="" :countWeight="400">
                </count-up></span>
            <span><count-up :id-name="'code_' + '预览总量'" :end-val="cites" countSize="" :countWeight="400">
                </count-up></span>
            <span><count-up :id-name="'code_' + '分享总量'" :end-val="sharecount" countSize="" :countWeight="400">
                </count-up></span>
        </div>
        <div class="resource-display-title">
            <span>建设总量</span><span>预览总量</span><span>分享总量</span>
        </div>
    </div>
</template>
<script>
import CountUp from "../../../components/countUp.vue";
import { getPlatformResourceStatAPI } from "@/service/api.js"
export default {
    name: 'resource-display',
    components: {
        CountUp,
    },
    props: {
        //区域id
        regionId: {
            type: String,
            default: ''
        },
        regionType: {
            type: String,
            default: ''
        },
        //省id
        provinceId: {
            type: String,
            default: ''
        },
        //市id
        cityId: {
            type: String,
            default: ''
        },
        //区id
        districtId: {
            type: String,
            default: ''
        },
        //乡镇地址
        address: {
            type: String,
            default: ''
        },
        //学校id
        schoolId: {
            type: String,
            default: ''
        },
        //开始时间
        startTime: {
            type: String,
            default: ""
        },
        //结束时间
        endTime: {
            type: String,
            default: ""
        },
    },
    computed: {
        intervalTime() {
            return [this.startTime, this.endTime];
        }
    },
    watch: {
        intervalTime() {
            this.getPlatformResourceStat();
        },
        schoolId() {
            this.getPlatformResourceStat();
        },
        address() {
            this.getPlatformResourceStat();
        }
    },
    data() {
        return {
            rescourcecount: 0,
            cites: 0,
            sharecount: 0,
        }
    },
    methods: {
        /**
          * @name 获取平台资源统计
          */
        getPlatformResourceStat() {
            let params = {
                regionId: this.regionId,
                provinceId: this.provinceId,
                cityId: this.cityId,
                districtId: this.districtId,
                address: this.address,
                startTime: this.startTime ? `${this.startTime} 00:00:00` : '',
                endTime: this.endTime ? `${this.endTime} 23:59:59` : '',
                regionType: this.regionType,
                schoolId: this.schoolId,
            }
            getPlatformResourceStatAPI(params).then((res) => {
                this.rescourcecount = res.rsNum,
                    this.sharecount = res.wpfxRsNum
                    this.cites = res.rsViewNum
            }).catch((err) => { })
        }
    },
    mounted() {
        //  获取平台资源统计
        this.getPlatformResourceStat();

    }
}
</script>
<style lang="scss" scoped>
.resource-display {
    background: url("~@/assets/images/qingxudataboard/center-top-bg.png") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 110px;

    .resource-display-title {
        width: 100%;
        margin-top: 5px;
        display: flex;
        justify-content: space-around;

        & span {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #5B90E6;
        }
    }

    .resource-display-value {
        width: 100%;
        display: flex;
        justify-content: space-around;

        & span {
            width: 33%;
            margin-top: 5px;
            font-size: 40px;
            font-family: DigifaceWide;
            font-weight: 400;
            color: #0EFCFF;

            @font-face {
                font-family: DigifaceWide;
                src: url('../../../assets/fonts/DigifaceWide Regular.ttf'); //字体路径
            }
        }
    }
}
</style>